import {
  ApiEpBilling,
  IApiEpBillingRecurringPaymentListReq,
  IApiEpBillingRecurringPaymentRetrieveReq,
} from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.recurring_payment";

export const useEpBillingRecurringPayment = (options: {
  req: IApiEpBillingRecurringPaymentRetrieveReq;
  useQueryOptions?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.RecurringPayment.retrieve>>
    >,
    "queryKey" | "queryFn"
  >;
}) => {
  const { data: recurringPayment, isLoading: isRecurringPaymentLoading } =
    useQuery(
      [KEY, options.req],
      () => ApiEpBilling.RecurringPayment.retrieve(options.req),
      options?.useQueryOptions,
    );
  return {
    billingRecurringPayment: recurringPayment, // WARNING: deprecated
    isBillingRecurringPaymentLoading: isRecurringPaymentLoading, // WARNING: deprecated
    isRecurringPaymentLoading,
    recurringPayment,
  };
};

useEpBillingRecurringPayment.KEY = KEY;

export const useEpBillingRecurringPaymentList = (options?: {
  req?: IApiEpBillingRecurringPaymentListReq;
  useQueryOptions?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.RecurringPayment.list>>
    >,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    data: recurringPaymentListRes,
    isLoading: isRecurringPaymentListLoading,
  } = useQuery(
    [KEY],
    () => ApiEpBilling.RecurringPayment.list(options?.req),
    options?.useQueryOptions,
  );

  const recurringPaymentList = recurringPaymentListRes?.results;

  return {
    billingRecurringPaymentList: recurringPaymentListRes, // WARNING: deprecated
    isBillingRecurringPaymentListLoading: isRecurringPaymentListLoading, // WARNING: deprecated
    isRecurringPaymentListLoading,
    recurringPaymentList,
  };
};

useEpBillingRecurringPaymentList.KEY = KEY;
